import { useFormik } from "formik";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { userOption, userResult } from '../../models/orders/order-list-model';
import { useState, useEffect, useRef } from "react";
import orderServices from '../../services/orders/orderservice';
import { InputNumber } from "primereact/inputnumber";
import ComplaintService from "../../services/complaint/ComplaintService";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import { complaintmodel, InvoiceNoDetails, ProductDetails, userProduct, CompCategory
  ,userCompCategory, CompType, userCompType, CompStatus, userCompStatus,
  customerDetails,userComplaintResult
 } from "../../models/complaints/complaint-model";
 import AppLoading from "../app-loading/app-loading";
import { json } from "stream/consumers";
import { store } from "../../redux/store";

interface UpdateComplaintProps {
  isUpdate: boolean;
  handleOnSuccess: () => void;
  updateComplaintInfo: complaintmodel;
  oldUserList:complaintmodel[];
  updatedData:any;
}

const UpdateComplaintDataTable: React.FC<UpdateComplaintProps> = ({ isUpdate, handleOnSuccess, updateComplaintInfo, oldUserList, updatedData }) => {
  const [categories, setCategories] = useState<any>("");
  const [orderUsers, setOrderUsers] = useState<customerDetails[]>([]);
  const [orderUser, setOrderUser] = useState<userComplaintResult[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>();
  const [orderInvoices, setOrderInvoices] = useState<InvoiceNoDetails[]>([]);
  const [selectedInvoiceNo, setSelectedInvoiceNo] = useState<number>(0);
  const [imageFile, setImageFile] = useState<any>(null);
  const [videoFile, setVideoFile] = useState<any>(null);
  const [products, setProducts] = useState<ProductDetails[]>([]);
  const [orderProduct, setOrderProduct] = useState<userProduct[]>([]);
  const [selectedProducts,setSelectedProducts] = useState<any>();
  const [selectedProductId, setSelectedProductId] = useState<number>(0);
  const [compCat, setcompCat] = useState<CompCategory[]>([]);
  const [CompCategorys, setCompCategorys] = useState<userCompCategory[]>([]);
  const [selectedCompCategory, setSelectedCompCategory] = useState<any>();
  const [compTyp, setcompTyp] = useState<CompType[]>([]);
  const [CompTyps, setCompTyps] = useState<userCompType[]>([]);
  const [selectedCompTyp, setSelectedCompType] = useState<any>();
  const [compStatus, setcompStatus] = useState<CompStatus[]>([]);
  const [CompStatuss, setCompStatuss] = useState<userCompStatus[]>([]);
  const [selectedCompStatus, setSelectedCompStatus] = useState<any>();
  const toast = useRef<Toast>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const blankAdminDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: '' }];
  const [adminUsers, setAdminUsers] = useState<userOption[]>(blankAdminDetail);
  const [adminUser, setAdminUser] = useState<userResult[]>([]);
  const [selectedAdmin, setSelectedAdmin] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number>(0);
  const [loginUser,setLoginUser] = useState<any>();
  const inputFieldClasses = "w-full p-2 border-round border-1 border-300";
  const textareaClasses = `${inputFieldClasses} resize-none`;
  const dropdownClasses = `${inputFieldClasses} p-dropdown`;

  useEffect(() => {
    if (orderUsers && orderUsers.length > 0) {
      setOrderUser(orderUsers.map((user) => {
        return {
          userID: user.userID,
          userName:user.name,
          detail: `${user.name}, ${user.primaryContactNbr}`,
          phoneNo: user.primaryContactNbr
        };
      }));
    }

    if (adminUsers && adminUsers.length > 0) {
      setAdminUser(adminUsers.map((admin) => {
        return {
          userID: admin.userID,
          userName:admin.name,
          detail: `${admin.name}, ${admin.primaryContactNbr}`,
        };
      }));
    }

    if (products && products.length > 0) {
      setOrderProduct(products.map((product) => {
        return {
          productId: product.productId,
          productName: product.name,
          orderInvoiceDetailID: product.orderInvoiceDetailID,
          detail: `${product.name}, Quantity - ${product.quantity}`,
        };
      }));
    }

    if (compCat && compCat.length > 0) {
      setCompCategorys(compCat.map((compCategory) => {
        return {
          complaintCategoryId: compCategory.complaintCategoryId,
          complaintName: compCategory.complaintName,
        };
      }));
    }

    if (compTyp && compTyp.length > 0) {
      setCompTyps(compTyp.map((CompType) => {
        return {
          complaintTypeId: CompType.complaintTypeId,
          complaintName: CompType.complaintName,
        };
      }));
    }

    if (compStatus && compStatus.length > 0) {
      setCompStatuss(compStatus.map((CompStatus) => {
        return {
          statusId: CompStatus.statusId,
          name: CompStatus.name,
        };
      }));
    }
    setComplaintData()
  }, [orderUsers, products, compCat, compTyp, compStatus, adminUsers]);

  useEffect(() => {
    fetchComplaintCategory();
    fetchComplaintType();
    fetchComplaintStatus();
    var LoginDetails = localStorage.getItem('user')
    if(LoginDetails != null)
    {
      setLoginUser(JSON.parse(LoginDetails));
    }
  }, []);

  const handlePhoneDropdownChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    setSelectedUserId(e.value);
    setFieldValue("userId", e.value);
    const invoices = await ComplaintService.getUserInvoices(e.value);
    setOrderInvoices(invoices);
  };

  const handlePhoneDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response);
        }
      });
    }
  };

  const handleAdminDropdownChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedAdmin = e.value;
    const adminName = adminUsers.filter(x => x.userID === e.value)[0].name;
    setSelectedAdmin(selectedAdmin);
    setFieldValue("actionedBy", e.value);
    setFieldValue("actionByName", adminName);
  };

  const handleAdminDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      ComplaintService.getAdminUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setAdminUsers(response);
        }
      });
    }
  };

  const handleInvoiceNoDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      ComplaintService.getUserAllInvoicesList({InvoiceNo : e.filter,UserId : updateComplaintInfo.customerId}).then((response: userOption[]) => {
        if (response.length > 0) {
          setAdminUsers(response);
        }
      });
    }
  };

  const handleInvoiceChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const products = await ComplaintService.getInvoicedproducts(e.value);
    setFieldValue("orderInvoiceId", e.value);
    setProducts(products);
    setCategories("");
    setSelectedProductId(0);
    setSelectedInvoiceNo(e.value);
  };

  const handleImageUpload = (e: any) => {
    setImageFile(e.files[0]);
  };

  const handleVideoUpload = (e: any) => {
    setVideoFile(e.files[0]);
  };

  const handleImageCancel = () => {
    setImageFile(null);
  };

  const handleVideoCancel = () => {
    setVideoFile(null);
  };

  const handleProductChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const category = await ComplaintService.getProductCategory(e.value);
    setFieldValue("productId", e.value);
    const productName = products.filter(product => product.productId === e.value)[0].name;
    setFieldValue("productName",productName)
    setCategories(category);
    setFieldValue("productCategoryName",category[0].categoryName)
    setSelectedProductId(e.value);
  };

    const severityItems = [
    { name: "High", severityID: 1 },
    { name: "Medium", severityID: 2 },
    { name: "Low", severityID: 3}
  ];

  const handleCompCategoryChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedCompCategory = e.value;
    const complaintCategoryName = compCat.filter(x => x.complaintCategoryId === e.value)[0].complaintName;
    setSelectedCompCategory(selectedCompCategory);
    setFieldValue("complaintCategory", e.value);
    setFieldValue("complaintCategoryName", complaintCategoryName);
  };

  const fetchComplaintCategory = async () => {
    const CompCat = await ComplaintService.getComplaintCategory();
    setcompCat(CompCat);
  };

  const handleCompTypeChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedCompType = e.value;
    const compTypName = compTyp.filter(x => x.complaintTypeId === e.value)[0].complaintName;
    setSelectedCompType(selectedCompType);
    setFieldValue("complaintType", e.value);
    setFieldValue("complaintTypeName", compTypName)
  };

  const fetchComplaintType = async () => {
    const CompTyp = await ComplaintService.getComplaintType();
    setcompTyp(CompTyp);
  };

  const handleComStatusChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedCompStatus = e.value;
    const statusName = CompStatuss.filter(x => x.statusId === e.value)[0].name;
    setSelectedCompStatus(selectedCompStatus);
    setFieldValue("status", e.value);
    setFieldValue("statusName", statusName)
  };

  const fetchComplaintStatus = async () => {
    const CompStatus = await ComplaintService.getComplaintStatus();
    setcompStatus(CompStatus);
  };

  const setComplaintData = async () => {
    var selectedUser = orderUser.filter(x => x.userID === updateComplaintInfo.customerId);
    var selectedInvoice = orderInvoices.filter(invoice => invoice.orderInvoiceID === updateComplaintInfo.purchaseInvoiceId);
    var selectedProduct = products.filter(product => product.productId === updateComplaintInfo.productId);
    const selectedAdmin = adminUsers.filter(admin => admin.userID === updateComplaintInfo.actionById);

    if(selectedUser.length === 0){
      selectedUser = orderUser.filter(x => x.userID === selectedUserId);
    }
    if(selectedInvoice.length === 0){
      selectedInvoice = orderInvoices.filter(invoice => invoice.orderInvoiceID === updateComplaintInfo.purchaseInvoiceId) 
    }
    if(selectedInvoiceNo > 0){
      selectedInvoice = orderInvoices.filter(invoice => invoice.orderInvoiceID === selectedInvoiceNo) 
    }
    if(selectedProductId > 0){
      selectedProduct = products.filter(product => product.productId === selectedProductId);
    }
    formik.setValues({
      
      complaintsId: updateComplaintInfo.complaintId,
      complaintNumber: String(updateComplaintInfo.complaintNumber ?? ""),
      complaintDate: updateComplaintInfo.complaintDate ? formatLocalDate(new Date(updateComplaintInfo.complaintDate)) : "",
      userId: selectedUser.length === 1 ? selectedUser[0].userID : 0, 
      userName: selectedUser.length === 1 ? selectedUser[0].userName : "",
      userNo: selectedUser.length === 1 ? selectedUser[0].phoneNo : 0,
      orderInvoiceId : selectedInvoice.length === 1 ? selectedInvoice[0].orderInvoiceID : 0,
      productId : selectedProduct.length === 1 ? selectedProduct[0].productId : 0,
      productName : selectedProduct.length === 1 ? selectedProduct[0].name : "",
      productCategoryName : updateComplaintInfo.name,
      packingType: String(updateComplaintInfo.packingType ?? ""),
      dateCode: String(updateComplaintInfo.dateCodeBatchCode ?? ""),
      complaint: String(updateComplaintInfo.description ?? ""),
      image: String(updateComplaintInfo.complaintImage ?? ""),
      video: String(updateComplaintInfo.video ?? ""),
      category: updateComplaintInfo.name ?? [],
      complaintCategory: updateComplaintInfo.complaintCategoryId,
      complaintCategoryName: updateComplaintInfo.complaintCategory,
      complaintType: updateComplaintInfo.complaintTypeId,
      complaintTypeName: updateComplaintInfo.complaintType,
      remarks: String(updateComplaintInfo.remarks ?? ""),
      correctiveAction: String(updateComplaintInfo.correctiveAction ?? ""),
      preventiveAction: String(updateComplaintInfo.preventiveAction ?? ""),
      customerSupportAction: String(updateComplaintInfo.customerSupportAction ?? ""),
      actionedBy: selectedAdmin.length === 1 ? selectedAdmin[0].userID : 0,
      actionByName : selectedAdmin.length === 1 ? selectedAdmin[0].name : "",
      status: updateComplaintInfo.statusId,
      statusName: updateComplaintInfo.status,
      actionDate: updateComplaintInfo.actionDate ? formatLocalDate(new Date(updateComplaintInfo.actionDate)) : "",
      satisfactionLevel: String(updateComplaintInfo.complainantSatisfaction ?? ""),
      severity: String(updateComplaintInfo.severity ?? ""),
      copqInRs: String(updateComplaintInfo.copqInRs ?? ""),
    });

    setSelectedUser(selectedUser);
    setSelectedInvoiceNo(formik.values.orderInvoiceId);
    setSelectedProducts(selectedProduct);
    setSelectedAdmin(selectedAdmin);
    setSelectedCompCategory(CompCategorys.find((category) => category.complaintCategoryId === updateComplaintInfo.complaintCategoryId));
    setSelectedCompType(CompTyps.find((type) => type.complaintTypeId === updateComplaintInfo.complaintTypeId));
    setSelectedCompStatus(CompStatuss.find((status) => status.statusId === updateComplaintInfo.statusId));
  };

  const formatLocalDate = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  useEffect(() => {
    if (isUpdate && updateComplaintInfo) {
      const fetchData = async () => {
        // Fetch all users
        const users = await orderServices.getUserDetailComplaint(updateComplaintInfo.customerId);
        setOrderUsers(users); // Set the users in state

        // Fetch other data (invoices, products, admins, categories, types, statuses)
        const invoices = await ComplaintService.getUserAllInvoices(updateComplaintInfo.customerId);
        setOrderInvoices(invoices);
  
        const products = await ComplaintService.getInvoicedproducts(updateComplaintInfo.purchaseInvoiceId);
        setProducts(products);

        const category = await ComplaintService.getProductCategory(updateComplaintInfo.productId);
        setCategories(category);
  
        const admins = await ComplaintService.getAdminDetailComplaint();
        setAdminUsers(admins);
  
        const categories = await ComplaintService.getComplaintCategory();
        setcompCat(categories);
  
        const types = await ComplaintService.getComplaintType();
        setcompTyp(types);
  
        const statuses = await ComplaintService.getComplaintStatus();
        setcompStatus(statuses);
  
        // Set the form data
        //setComplaintData();
      };
  
      fetchData();
    }
  }, [isUpdate, updateComplaintInfo]);

  const formik = useFormik({
    initialValues: {
      complaintsId: isUpdate && updateComplaintInfo ? updateComplaintInfo.complaintId : null,
      complaintNumber: isUpdate && updateComplaintInfo ? updateComplaintInfo.complaintNumber : null,
      complaintDate: isUpdate && updateComplaintInfo ? formatLocalDate(new Date(updateComplaintInfo.complaintDate)) : "",
      userId: isUpdate && updateComplaintInfo ? updateComplaintInfo.customerId : 0,
      userName: isUpdate && updateComplaintInfo ? updateComplaintInfo.custName : "",
      userNo: isUpdate && updateComplaintInfo ? updateComplaintInfo.mobile : "",
      orderInvoiceId: isUpdate && updateComplaintInfo ? updateComplaintInfo.purchaseInvoiceId : 0,
      productId : isUpdate && updateComplaintInfo ? updateComplaintInfo.productId : 0,
      productName: "",
      productCategoryName: "",
      packingType: "",
      dateCode: "",
      complaint: "",
      image: "",
      video: "",
      category: categories,
      complaintCategory: isUpdate && updateComplaintInfo ? updateComplaintInfo.complaintCategoryId : 0,
      complaintCategoryName: isUpdate && updateComplaintInfo ? updateComplaintInfo.name : "",
      complaintType: isUpdate && updateComplaintInfo ? updateComplaintInfo.complaintTypeId : 0,
      complaintTypeName: isUpdate && updateComplaintInfo ? updateComplaintInfo.complaintType : "",
      remarks: "",
      correctiveAction: "",
      preventiveAction: "",
      customerSupportAction: "",
      actionedBy: isUpdate && updateComplaintInfo ? updateComplaintInfo.actionedbyId : 0,
      actionByName: isUpdate && updateComplaintInfo ? updateComplaintInfo.actionedbyname : "",
      status: isUpdate && updateComplaintInfo ? updateComplaintInfo.statusId : 0,
      statusName : isUpdate && updateComplaintInfo ? updateComplaintInfo.status : "",
      actionDate: isUpdate && updateComplaintInfo ?  formatLocalDate(new Date(updateComplaintInfo.actionDate)) : "",
      satisfactionLevel: "",
      severity: "",
      copqInRs: "",
    },
    validationSchema: Yup.object({
      userId: Yup.string().required("Please enter user details"),
      orderInvoiceId: Yup.string().required("Please select invoice number"),
      productId: Yup.string().required("Please select product name"),
      complaintCategory: Yup.string().required("Please select complaint category"),
      complaintType: Yup.string().required("Please select complaint type"),
      actionedBy: Yup.string().required("Please select action by"),
      status: Yup.string().required("Please select status"),
      complaintDate: Yup.string().required("Please select complaintDate")
    }),

    onSubmit: async (data) => {
      if (isSubmitted) return;
      setIsSubmitted(true);
      const complaint = {
        complaintsId: data.complaintsId,
        complaintNumber: data.complaintNumber,
        complaintDate: data.complaintDate,
        customerId: data.userId,
        purchaseInvoiceId: data.orderInvoiceId,
        productId: data.productId,
        packingType: data.packingType,
        dateCodeBatchCode: data.dateCode,
        description: data.complaint,
        image: data.image,
        video: data.video,
        complaintCategoryId: data.complaintCategory,
        complaintTypeId: data.complaintType,
        remarks: data.remarks,
        correctiveAction: data.correctiveAction,
        preventiveAction: data.preventiveAction,
        customerSupportAction: data.customerSupportAction,
        actionedBy: data.actionedBy,
        statusId: data.status,
        actionDate: data.actionDate === "" ? null : data.actionDate,
        complainantSatisfaction: data.satisfactionLevel,
        severity: data.severity,
        copqInRs: data.copqInRs,
        productCategoryId: categories.length > 0 ? categories[0].categoryID : null,
      };

      const oldUserIndex = oldUserList.findIndex(x => x.complaintId === data.complaintsId);

      oldUserList[oldUserIndex].complaintDate = data.complaintDate;
      oldUserList[oldUserIndex].customerId = data.userId;
      oldUserList[oldUserIndex].custName = data.userName;
      oldUserList[oldUserIndex].mobile = Number(data.userNo) ;
      oldUserList[oldUserIndex].purchaseInvoiceId = data.orderInvoiceId;
      oldUserList[oldUserIndex].productId = data.productId;
      oldUserList[oldUserIndex].productName = data.productName;
      oldUserList[oldUserIndex].packingType = data.packingType;
      oldUserList[oldUserIndex].dateCodeBatchCode = data.dateCode;
      oldUserList[oldUserIndex].name = data.productCategoryName;
      oldUserList[oldUserIndex].complaintImage = data.image;
      oldUserList[oldUserIndex].video = data.video;
      oldUserList[oldUserIndex].complaintCategoryId = data.complaintCategory;
      oldUserList[oldUserIndex].complaintTypeId = data.complaintType;
      oldUserList[oldUserIndex].remarks = data.remarks;
      oldUserList[oldUserIndex].correctiveAction = data.correctiveAction;
      oldUserList[oldUserIndex].preventiveAction = data.preventiveAction;
      oldUserList[oldUserIndex].customerSupportAction = data.customerSupportAction;
      oldUserList[oldUserIndex].actionById = data.actionedBy;
      oldUserList[oldUserIndex].actionedbyname =  data.actionByName;
      oldUserList[oldUserIndex].statusId = data.status;
      oldUserList[oldUserIndex].status = data.statusName;
      oldUserList[oldUserIndex].actionDate = data.actionDate;
      oldUserList[oldUserIndex].complainantSatisfaction = data.satisfactionLevel;
      oldUserList[oldUserIndex].severity = data.severity;
      oldUserList[oldUserIndex].copqInRs = data.copqInRs;
      oldUserList[oldUserIndex].productCategoryId = complaint.productCategoryId;
      oldUserList[oldUserIndex].description = data.complaint;
      oldUserList[oldUserIndex].complaintType = data.complaintTypeName;
      oldUserList[oldUserIndex].updatedBy = loginUser.userID;
      oldUserList[oldUserIndex].updatedbyname = loginUser.name;
      oldUserList[oldUserIndex].updatedDate = formatLocalDate(new Date());
      oldUserList[oldUserIndex].complaintCategory = data.complaintCategoryName;

      try {
        const response = await ComplaintService.updateComplaint(complaint);
        if (response.isSuccess) {
          handleOnSuccess();
          updatedData(oldUserList);
        } else {
          toast.current?.show({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
        }
      } catch (error) {
        console.error("Error during complaint submission", error);
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to update complaint', life: 3000 });
      } finally {
        setIsSubmitted(false);
      }
    },
  });

return (
    <>
      <Toast ref={toast} position="top-center" />
      <div className="col-12 flex align-items-stretch flex-wrap">
        <div className="flex flex-1 bg-white align-items-center justify-content-center">
          <form onSubmit={formik.handleSubmit} className="w-full">
            <h5 className="border-round mb-4 p-3 order-top-color p-2 panel-header-text text-center ">
              Update Complaint
            </h5>
            <div className="p-fluid formgrid grid">
              <div className="col-12">
                <div className="grid">
                  {/* Complaint Date */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="complaintDate" className="block mb-2 font-bold required-label">
                        Complaint Date <span className="text-red-500">*</span>
                      </label>
                      <InputText
                        type="date"
                        id="complaintDate"
                        name="complaintDate"
                        value={formik.values.complaintDate}
                        onChange={formik.handleChange}
                        className={classNames(inputFieldClasses, {
                          'p-invalid': formik.errors.complaintDate && formik.touched.complaintDate,
                        })}
                      />
                      {formik.errors.complaintDate && formik.touched.complaintDate && (
                        <small className="p-error block mt-1">{formik.errors.complaintDate as string}</small>
                      )}
                    </div>
                  </div>

                  {/* User Info */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="userMobile" className="block mb-2 font-bold required-label">
                        User Info <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        id="userMobile"
                        name="userMobile"
                        options={orderUser}
                        optionLabel="detail"
                        optionValue="userID"
                        value={formik.values.userId}
                        onChange={(e: DropdownChangeEvent) => handlePhoneDropdownChange(e, formik.setFieldValue)}
                        onFilter={handlePhoneDropdownFilter}
                        filter
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.userId && formik.touched.userId,
                        })}
                        placeholder="Select User"
                      />
                      {formik.errors.userId && formik.touched.userId && (
                        <small className="p-error block mt-1">{formik.errors.userId as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Purchase Invoice Number */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="purchaseInvoiceNumber" className="block mb-2 font-bold required-label">
                        Purchase Invoice Number <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        id="purchaseInvoiceNumber"
                        name="purchaseInvoiceNumber"
                        options={orderInvoices}
                        optionLabel="invoiceNo"
                        optionValue="orderInvoiceID"
                        value={formik.values.orderInvoiceId}
                        onChange={(e: DropdownChangeEvent) => handleInvoiceChange(e, formik.setFieldValue)}
                        onFilter={handleInvoiceNoDropdownFilter}
                        filter
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.orderInvoiceId && formik.touched.orderInvoiceId,
                        })}
                        placeholder="Select Invoice"
                      />
                      {formik.errors.orderInvoiceId && formik.touched.orderInvoiceId && (
                        <small className="p-error block mt-1">{formik.errors.orderInvoiceId as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Product Name */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="productName" className="block mb-2 font-bold required-label">
                        Product Name <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        id="productName"
                        name="productName"
                        options={orderProduct}
                        optionLabel="detail"
                        optionValue="productId"
                        value={formik.values.productId}
                        onChange={(e: DropdownChangeEvent) => handleProductChange(e, formik.setFieldValue)}
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.productId && formik.touched.productId,
                        })}
                        placeholder="Select Product"
                      />
                      {formik.errors.productId && formik.touched.productId && (
                        <small className="p-error block mt-1">{formik.errors.productId as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Category (Read Only) */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="category" className="block mb-2 font-bold">
                        Category
                      </label>
                      <InputText
                        id="category"
                        name="category"
                        value={categories?.[0]?.categoryName || ''}
                        readOnly
                        className={`${inputFieldClasses} bg-gray-100`}
                      />
                    </div>
                  </div>

                  {/* Complaint Category */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="complaintCategory" className="block mb-2 font-bold required-label">
                        Complaint Category <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        name="complaintCategory"
                        id="complaintCategory"
                        options={CompCategorys}
                        optionLabel="complaintName"
                        optionValue="complaintCategoryId"
                        value={formik.values.complaintCategory}
                        onChange={(e: DropdownChangeEvent) => handleCompCategoryChange(e, formik.setFieldValue)}
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.complaintCategory && formik.touched.complaintCategory,
                        })}
                        placeholder="Select Complaint Category"
                      />
                      {formik.errors.complaintCategory && formik.touched.complaintCategory && (
                        <small className="p-error block mt-1">{formik.errors.complaintCategory as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Complaint Type */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="complaintType" className="block mb-2 font-bold required-label">
                        Complaint Type <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        name="complaintType"
                        id="complaintType"
                        options={CompTyps}
                        optionLabel="complaintName"
                        optionValue="complaintTypeId"
                        value={formik.values.complaintType}
                        onChange={(e: DropdownChangeEvent) => handleCompTypeChange(e, formik.setFieldValue)}
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.complaintType && formik.touched.complaintType,
                        })}
                        placeholder="Select Complaint Type"
                      />
                      {formik.errors.complaintType && formik.touched.complaintType && (
                        <small className="p-error block mt-1">{formik.errors.complaintType as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Status */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="status" className="block mb-2 font-bold required-label">
                        Status <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        name="status"
                        id="status"
                        options={CompStatuss}
                        optionLabel="name"
                        optionValue="statusId"
                        value={formik.values.status}
                        onChange={(e: DropdownChangeEvent) => handleComStatusChange(e, formik.setFieldValue)}
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.status && formik.touched.status,
                        })}
                        placeholder="Select Status"
                      />
                      {formik.errors.status && formik.touched.status && (
                        <small className="p-error block mt-1">{formik.errors.status as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-12 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="complaint" className="block mb-2 font-bold">
                        Description
                      </label>
                      <InputTextarea
                        id="complaint"
                        name="complaint"
                        rows={3}
                        value={formik.values.complaint}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('complaint', cleanedValue);
                        }}
                        className={textareaClasses}
                      />
                    </div>
                  </div>

                  {/* Remarks */}
                  <div className="col-12 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="remarks" className="block mb-2 font-bold">
                        Remarks
                      </label>
                      <InputTextarea
                        id="remarks"
                        name="remarks"
                        rows={3}
                        value={formik.values.remarks}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('remarks', cleanedValue);
                        }}
                        className={textareaClasses}
                      />
                    </div>
                  </div>

                  {/* Customer Support Action */}
                  <div className="col-12 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="customerSupportAction" className="block mb-2 font-bold">
                        Customer Support Action
                      </label>
                      <InputTextarea
                        id="customerSupportAction"
                        name="customerSupportAction"
                        rows={3}
                        value={formik.values.customerSupportAction}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('customerSupportAction', cleanedValue);
                        }}
                        className={textareaClasses}
                      />
                    </div>
                  </div>

                  {/* Actioned By */}
                  <div className="col-12 md:col-6 lg:col-4 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="actionedBy" className="block mb-2 font-bold required-label">
                        Actioned By <span className="text-red-500">*</span>
                      </label>
                      <Dropdown
                        name="actionedBy"
                        id="actionedBy"
                        options={adminUser}
                        optionLabel="detail"
                        optionValue="userID"
                        value={formik.values.actionedBy}
                        onChange={(e: DropdownChangeEvent) => handleAdminDropdownChange(e, formik.setFieldValue)}
                        onFilter={handleAdminDropdownFilter}
                        filter
                        className={classNames(dropdownClasses, {
                          'p-invalid': formik.errors.actionedBy && formik.touched.actionedBy,
                        })}
                        placeholder="Select Admin"
                      />
                      {formik.errors.actionedBy && formik.touched.actionedBy && (
                        <small className="p-error block mt-1">{formik.errors.actionedBy as string}</small>
                      )}
                    </div>
                  </div>

                  {/* Image Upload */}
                  <div className="col-12 md:col-6 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="image" className="block mb-2 font-bold">
                        Image
                      </label>
                      <FileUpload
                        name="image"
                        id="image"
                        mode="basic"
                        accept="image/*"
                        maxFileSize={1000000}
                        chooseLabel="Upload Image"
                        onUpload={(e) => {
                          if (e.files.length > 0) {
                            formik.setFieldValue("image", e.files[0].name);
                          }
                        }}
                        className={inputFieldClasses}
                      />
                      {formik.values.image && (
                        <div className="mt-2 text-sm">
                          <small>Current: {formik.values.image}</small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Video Upload */}
                  <div className="col-12 md:col-6 mb-3 px-3">
                    <div className="field">
                      <label htmlFor="video" className="block mb-2 font-bold">
                        Video
                      </label>
                      <FileUpload
                        name="video"
                        id="video"
                        mode="basic"
                        accept="video/*"
                        maxFileSize={5000000}
                        chooseLabel="Upload Video"
                        onUpload={(e) => {
                          if (e.files.length > 0) {
                            formik.setFieldValue("video", e.files[0].name);
                          }
                        }}
                        className={inputFieldClasses}
                      />
                      {formik.values.video && (
                        <div className="mt-2 text-sm">
                          <small>Current: {formik.values.video}</small>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Update Button */}
                  <div className="col-12 mt-4 px-3 flex justify-content-end">
                    <Button
                      type="submit"
                      label="Update Complaint"
                      className="p-button-primary w-full md:w-auto"
                      disabled={loading}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {loading && <AppLoading />}
    </>
  );
};

export default UpdateComplaintDataTable;